module.exports = __webpack_public_path__ + "static/media/bittorrent_cover.8250688b.svg";